/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { ReactElement, useState, useCallback, useEffect, useRef } from 'react';

import { FormHandles } from '@unform/core';
// import InputMask from 'react-input-mask';

import { Input, InputMask, Select, Textarea } from '~/components';
import InputTime from '~/components/InputTime';
import { useLoading } from '~/hooks/loading';
import { IMethod } from '~/models/Method';
import { MethodService } from '~/services';

import * as S from './styles';

interface IEditMethodFormProps {
  formName: string;
  formRef: React.RefObject<FormHandles>;
  handleSubmit: (data: IMethod) => void;
  methodId?: string;
}

function EditMethodForm({
  formName,
  formRef,
  handleSubmit,
  methodId,
}: IEditMethodFormProps): ReactElement {
  const { setLoading } = useLoading();
  const [method, setMethod] = useState<IMethod>({} as IMethod);
  const [initialData, setInitialData] = useState<IMethod>({} as IMethod);
  const [seriesQuantity, setSeriesQuantity] = useState<number>(0);
  const [seriesSeconds, setSeriesSeconds] = useState<number[]>([]);
  const [maxLength, setMaxLength] = useState<number>(0);
  const [
    recoverIntervalBetweenSeries,
    setRecoverIntervalBetweenSeries,
  ] = useState('');

  const totalActionRef = useRef<HTMLInputElement>(null);
  const intervalRecoveryTotalRef = useRef<HTMLInputElement>(null);
  // const intervalRecoveryBetweenSeriesRef = useRef<InputMask>(null);

  const handleGetMethod = useCallback(async () => {
    setLoading(true);
    const response = await MethodService.getOneMethod(methodId!);
    setMethod(response.data);
    setSeriesQuantity(response.data.series_number!);
    setSeriesSeconds(
      response.data.recovery_interval_between_series?.split('/').map(Number)!,
    );
    setRecoverIntervalBetweenSeries(
      response.data.recovery_interval_between_series ?? '',
    );

    setLoading(false);
  }, [methodId]);

  useEffect(() => {
    if (methodId) {
      handleGetMethod();
    }
  }, [handleGetMethod, methodId]);

  const handleInitialData = () => {
    setInitialData({
      professional_id: method?.professional_id,
      tranning_method: method.tranning_method,
      execution: method?.execution,
      technical_description: method?.technical_description,
      method_principle: method?.method_principle,
      series_number: method?.series_number ?? 0,
      total_action: method?.total_action ?? '00:00:00',
      total_time: method?.total_time ?? '00:00:00',
      interval_recovery_total: method?.interval_recovery_total ?? '00:00:00',
      recovery_interval_between_series:
        method?.recovery_interval_between_series,
      series_names: method?.series_names,
      series_number_of_repetitions: method?.series_number_of_repetitions,
      series_actions_time: method?.series_actions_time,
      series_recovery_Time: method?.series_recovery_Time,
      volume_total: method?.volume_total ?? 0,
    });
    formRef.current?.setFieldValue(
      'recovery_interval_between_series',
      method?.recovery_interval_between_series,
    );
    formRef.current?.setFieldValue('series_number', method?.series_number);
    formRef.current?.setFieldValue(
      'method_principle',
      method?.method_principle?.replaceAll('&', ', '),
    );
  };

  const resetDynamicInputs = (quantityFields: number) => {
    for (let count = 0; count < quantityFields; count++) {
      const elementIndex = count + 1;
      formRef.current?.setFieldValue(
        `series_names.name_of_serie_${elementIndex}`,
        '',
      );
      formRef.current?.setFieldValue(
        `series_number_of_repetitions.repetitions_serie_${elementIndex}`,
        '',
      );
      formRef.current?.setFieldValue(
        `series_actions_time.action_time_serie_${elementIndex}`,
        '',
      );
    }
  };

  useEffect(() => {
    handleInitialData();
  }, [formRef, method]);

  useEffect(() => {
    if (method) {
      for (let index = 0; index < seriesQuantity; index++) {
        formRef.current?.setFieldValue(
          `series_names.name_of_serie_${index + 1}`,
          method.series_names[`name_of_serie_${index + 1}`],
        );
        formRef.current?.setFieldValue(
          `series_number_of_repetitions.repetitions_serie_${index + 1}`,
          method.series_number_of_repetitions[`repetitions_serie_${index + 1}`],
        );
        formRef.current?.setFieldValue(
          `series_actions_time.action_time_serie_${index + 1}`,
          method.series_actions_time[`action_time_serie_${index + 1}`],
        );
      }
      // Reseta o campo caso já preenchido com vários segundos e não esteja equivalente com o número de séries
      // if (seriesSeconds.length - seriesQuantity >= 0) {
      //   formRef.current?.setFieldValue(`recovery_interval_between_series`, '');
      // }
    }
  }, [formRef, method, seriesSeconds.length]);

  useEffect(() => {
    if (seriesSeconds) {
      if (seriesSeconds.length === 1) {
        for (let index = 0; index < seriesQuantity - 1; index++) {
          const convertedValue = secondsToHMS(seriesSeconds[0]);
          formRef.current?.setFieldValue(
            `series_recovery_Time.time_of_recovery_serie_${index}`,
            convertedValue,
          );
        }
      } else {
        seriesSeconds.forEach((value, index) => {
          const convertedValue = secondsToHMS(value);
          formRef.current?.setFieldValue(
            `series_recovery_Time.time_of_recovery_serie_${index}`,
            convertedValue,
          );
        });
      }
    }
  }, [formRef, seriesQuantity, seriesSeconds]);

  // eslint-disable-next-line consistent-return
  const MethodSeries = () => {
    const dynamicInputs = [];
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < seriesQuantity!; index++) {
      const elementIndex = index + 1;
      dynamicInputs.push(
        <>
          <Input
            name={`series_names.name_of_serie_${elementIndex}`}
            label={`Série ${elementIndex}:`}
          />
          <Input
            name={`series_number_of_repetitions.repetitions_serie_${elementIndex}`}
            className="repetitions_serie"
            label="Número de repetições:"
          />
          <S.InputBlock>
            <p>Tempo de ação:</p>
            <InputTime
              name={`series_actions_time.action_time_serie_${elementIndex}`}
              className="action_time_serie"
              // disabled={elementIndex >= seriesQuantity}
            />
          </S.InputBlock>

          {!(index === seriesQuantity - 1) && (
            <S.InputBlock>
              <p>Intervalo de recuperação (entre séries):</p>
              <InputTime
                // name={`series_recovery_Time.time_of_recovery_serie_${elementIndex}`}
                name={`series_recovery_Time.time_of_recovery_serie_${elementIndex}`}
                className="time_of_recovery_serie"
                disabled
              />
            </S.InputBlock>
          )}
          {/* <S.InputBlock>
            <p>Intervalo de recuperação (entre séries):</p>
            <InputTime
              // name={`series_recovery_Time.time_of_recovery_serie_${elementIndex}`}
              name={`series_recovery_Time.time_of_recovery_serie_${index}`}
              className="time_of_recovery_serie"
              disabled
            />
          </S.InputBlock> */}
          <S.Divider />
        </>,
      );
    }
    return dynamicInputs;
  };

  function hmsToSeconds(s: string) {
    const b: any = s.split(':');
    return b[0] * 3600 + b[1] * 60 + (+b[2] || 0);
  }

  function secondsToHMS(secs: number) {
    function z(n: number) {
      return (n < 10 ? '0' : '') + n;
    }
    const sign = secs < 0 ? '-' : '';
    // eslint-disable-next-line no-param-reassign
    secs = Math.abs(secs);
    // eslint-disable-next-line no-bitwise
    return `${sign + z((secs / 3600) | 0)}:${z(((secs % 3600) / 60) | 0)}:${z(
      secs % 60,
    )}`;
  }

  function onFormChange() {
    // MethodSeries();
    setTimeout(() => {
      updateTotalRepetitions();
      calculateTotalInHMS('input.action_time_serie', 'total_action');
      calculateTotalInHMS(
        'input.time_of_recovery_serie',
        'interval_recovery_total',
      );
      calculateTotal();
    }, 0);
  }

  function updateTotalRepetitions() {
    let elementsCount = 0;
    const inputs = document.querySelectorAll(
      'input.repetitions_serie',
    ) as NodeListOf<HTMLInputElement>;

    inputs.forEach((element) => {
      elementsCount += Number(element.value);
    });

    formRef.current?.setFieldValue('volume_total', elementsCount);
  }

  const calculateRecoveryBetweenSeries = useCallback(() => {
    formRef.current?.setFieldValue('recovery_interval_between_series', '');
    for (let i = 0; i < seriesQuantity; i++) {
      const serieTimeValue = secondsToHMS(0);
      formRef.current?.setFieldValue(
        `series_recovery_Time.time_of_recovery_serie_${i}`,
        serieTimeValue,
      );
    }
    setRecoverIntervalBetweenSeries('');
    if (seriesQuantity > 0) {
      for (let index = 0; index <= 10; index++) {
        if (seriesQuantity === 1) {
          setMaxLength(0);
        }
        if (seriesQuantity === index + 1 && seriesQuantity > 1) {
          // eslint-disable-next-line prettier/prettier
          setMaxLength(3 * seriesQuantity + index);
        }
      }
    }
  }, [seriesQuantity]);

  const calculateIntervalRecovery = useCallback(() => {
    const recoverArray = recoverIntervalBetweenSeries.split('/');
    if (recoverArray.length === 1) {
      const serieTimeValue = secondsToHMS(Number(recoverArray[0]));
      for (let i = 0; i < seriesQuantity; i++) {
        formRef.current?.setFieldValue(
          `series_recovery_Time.time_of_recovery_serie_${i + 1}`,
          serieTimeValue,
        );
      }
    } else if (recoverArray.length > 1) {
      for (let i = 0; i < recoverArray.length; i++) {
        const serieTimeValue = secondsToHMS(Number(recoverArray[i]));

        formRef.current?.setFieldValue(
          `series_recovery_Time.time_of_recovery_serie_${i + 1}`,
          serieTimeValue,
        );
      }
    }
  }, [recoverIntervalBetweenSeries]);

  function calculateTotalInHMS(inputClass: string, inputForResult: string) {
    const formattedTimesInHMS: number[] = [];
    const inputs = document.querySelectorAll(
      inputClass,
    ) as NodeListOf<HTMLInputElement>;

    inputs.forEach((element) => {
      const elementSeconds = hmsToSeconds(element.value);
      formattedTimesInHMS.push(
        Number.isNaN(elementSeconds) ? 0 : hmsToSeconds(element.value),
      );
    });

    const total = formattedTimesInHMS.reduce((total, numero) => {
      return total + numero;
    }, 0);

    const totalConvertedToHMS = secondsToHMS(total);
    formRef.current?.setFieldValue(inputForResult, totalConvertedToHMS);
  }

  function calculateTotal() {
    const totalActionSeconds = hmsToSeconds(
      totalActionRef?.current?.value ?? '00:00:00',
    );

    const intervalRecoverySeconds = hmsToSeconds(
      intervalRecoveryTotalRef?.current?.value ?? '00:00:00',
    );

    const totalConvertedToHMS = secondsToHMS(
      totalActionSeconds + intervalRecoverySeconds,
    );
    formRef.current?.setFieldValue('total_time', totalConvertedToHMS);
  }

  useEffect(() => {
    calculateRecoveryBetweenSeries();
  }, [calculateRecoveryBetweenSeries]);

  useEffect(() => {
    calculateIntervalRecovery();
  }, [calculateIntervalRecovery]);

  return (
    <S.FormWrapper
      initialData={initialData}
      id={formName}
      ref={formRef}
      onChange={onFormChange}
      onSubmit={handleSubmit}
    >
      <Input name="tranning_method" label="Método:" />
      <Input
        name="method_principle"
        label="Princípio ativo: (separe por ',')"
      />
      <Input name="execution" label="Execução:" />
      <Textarea
        containerStyle={{ gridColumn: '1 / -1' }}
        name="technical_description"
        label="Descrição técnica:"
      />
      <S.InputBlock>
        <p>Intervalo de recuperação entre séries:</p>
        <p>(separe com '/')</p>
        <Input
          name="recovery_interval_between_series"
          // placeholder="010/020/015"
          value={recoverIntervalBetweenSeries}
          onChange={(event) => {
            formRef.current?.setFieldValue(
              'recovery_interval_between_series',
              event.target.value,
            );
            setRecoverIntervalBetweenSeries(event.target.value);
          }}
          disabled={maxLength <= 0}
          maxLength={maxLength}
        />
      </S.InputBlock>
      <S.InputBlock>
        <p>N° de séries:</p>
        <Select
          name="series_number"
          options={Array.from({ length: 10 }, (_, i) => {
            return { label: `${i + 1}`, value: i + 1 };
          })}
          onChange={(event) => {
            resetDynamicInputs(Number(event.target.value));
            setSeriesQuantity(Number(event.target.value));
          }}
        />
      </S.InputBlock>
      <S.Divider />
      {MethodSeries()}

      {/* //! Parte final só da visualização */}
      <Input disabled name="volume_total" label="Volume N° de repetições:" />
      <Input
        disabled
        name="total_action"
        ref={totalActionRef}
        label="Tempo de ação total:"
      />
      <Input
        disabled
        name="interval_recovery_total"
        ref={intervalRecoveryTotalRef}
        label="Intervalo de recuperação total:"
      />
      <Input disabled name="total_time" label="Tempo total:" />
    </S.FormWrapper>
  );
}

EditMethodForm.defaultProps = {
  methodId: '',
};

export default EditMethodForm;
